export default __webpack_public_path__ + "static/Lazada3-5e6eddaeab403bc62b9dac655013e4d0.jpg";